const UploadIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.28887 12.6427C3.5056 12.6436 2.74955 12.353 2.16556 11.8266C1.58158 11.3003 1.21072 10.5751 1.12404 9.7901C1.03736 9.00509 1.24095 8.21543 1.69581 7.5724C2.15067 6.92938 2.82481 6.4782 3.58909 6.30532C3.36796 5.26533 3.56557 4.17935 4.13845 3.28629C4.71133 2.39323 5.61256 1.76624 6.64387 1.54324C7.67517 1.32025 8.75209 1.51953 9.63769 2.09723C10.5233 2.67494 11.1451 3.58375 11.3662 4.62373H11.4457C12.4317 4.62274 13.3829 4.99123 14.1147 5.65768C14.8464 6.32413 15.3065 7.24099 15.4056 8.23027C15.5047 9.21956 15.2357 10.2107 14.6509 11.0112C14.0661 11.8118 13.2072 12.3647 12.2409 12.5625M10.6505 10.237L8.26489 7.83133M8.26489 7.83133L5.87928 10.237M8.26489 7.83133V17.4541"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UploadIcon;
